import React, { useEffect } from "react";
import {
  Box,
  CircularProgress,
} from "@mui/material";
import Layout from "../../components/Layout";
import { useAppContext } from "../../context/AppContext";
import { useLogoSrc } from "../../hooks/useLogoSrc";
import { isTokenExpired } from "../../utils/tokenUtils";
import { cookieHelpers } from "../../utils/cookieUtils";

const DistributorSuccessful: React.FC = () => {
  const { setCurrentView, token } = useAppContext();
  const logoSrc = useLogoSrc();

  useEffect(() => {
    const validateAndRedirect = () => {
      // Check if distributor token exists
      const storedToken = token || cookieHelpers.getToken('distributor');
      
      if (!storedToken || isTokenExpired(storedToken)) {
        // No distributor token found, redirect to login
        setCurrentView("distributor-login");
        return;
      }

      // Token is valid, proceed to welcome page after a short delay
      const timer = setTimeout(() => {
        setCurrentView("distributor-welcome");
      }, 500);

      return () => clearTimeout(timer);
    };

    validateAndRedirect();
  }, [setCurrentView, token]);

  return (
    <Layout showBackButton={false} mode="fit">
      <Box
        sx={{
          width: '100%',
          minHeight: '100vh',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          padding: '20px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt="Company Logo"
          sx={{ 
            height: { xs: "2.5rem", sm: "3.5rem", md: "4.5rem" },
            width: "100%", 
            objectFit: "contain",
            mb: 4,
          }}
        />
        
        <CircularProgress 
          size={60}
          sx={{ 
            color: "var(--color-text-primary)",
          }} 
        />
      </Box>
    </Layout>
  );
};

export default DistributorSuccessful;